export default __webpack_public_path__ + "static/media/shareDrive.f2a85795.svg";